interface IEditorSettings {
  sitePage: any
  widget: any
  widgets: any
  EditorFromMeta: any
  updateRedactorSettings: (settings: any) => void
}

export const EditorSettings = ({
  sitePage,
  widgets,
  EditorFromMeta,
  widget,
  updateRedactorSettings,
}: IEditorSettings) => {
  return (
    <EditorFromMeta
      viewModel={widget.i}
      currentPage={sitePage}
      widgets={widgets}
      updateRedactorSettings={updateRedactorSettings}
    />
  )
}
